import styled from 'styled-components';

export const MerchantSubscriptionFeeWrapper = styled.div``;
